import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Heart, Lock, Menu, Package, Search, ShoppingBag, User } from "lucide-react";

import {
  get_cart_products,
  get_wishlist_products,
} from "../store/reducers/cardReducer";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { FaLock, FaUser } from "react-icons/fa";
import { AiFillHeart, AiFillShopping } from "react-icons/ai";

const HeadersDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { categorys } = useSelector((state) => state.home);
  const { userInfo, profileImage } = useSelector((state) => state.auth);
  const { card_product_count, wishlist_count } = useSelector(
    (state) => state.card
  );

  const { pathname } = useLocation();
  const [showShidebar, setShowShidebar] = useState(true);
  const [categoryShow, setCategoryShow] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [category, setCategory] = useState("");

  const search = () => {
    navigate(`/products/search?category=${category}&value=${searchValue}`);
  };

  const redirect_cart_page = () => {
    if (userInfo) {
      navigate(`/cart`);
    } else {
      navigate(`/login`);
    }
  };
  const initial = () => {
    navigate("/");
  };
  useEffect(() => {
    if (userInfo) {
      dispatch(get_cart_products(userInfo.id));
      dispatch(get_wishlist_products(userInfo.id));
    }
  }, [userInfo]);

  return (
    <div className="w-full py-5">
      <div className="w-[85%] lg:w-[90%] mx-auto">
        <div className="flex w-full flex-wrap justify-between md-lg:gap-4">
          <div className="flex justify-between items-center md-lg:w-full">
            <img
              onClick={initial}
              className="w-[60px] h-auto cursor-pointer"
              src={`${process.env.REACT_APP_URL}/images/omahlogoupdated.png`}
              alt="logo"
            />

          </div>

          <div className="flex items-center justify-between md:w-full sm:justify-between sm:w-full">
            <button
              onClick={search}
              className="flex items-center nex_button button_100 font-semibold text-white hover:opacity-90 h-[40px]"
            >
              Sell online <Package className="ml-2" size={24} />
            </button>
            <div className="flex items-center">
            {userInfo ? (
              <Link
                className="flex cursor-pointer justify-center items-center gap-2 text-sm ml-5"
                to="/dashboard"
              >
                <span className="w-8 h-8 rounded-full overflow-hidden bg-gray-200 flex items-center justify-center shrink-0 border border-gray-300">
                  {profileImage ? (
                    <img src={profileImage} alt={userInfo.name} className="w-full h-full object-cover" />
                  ) : (
                    <span className="text-xs font-bold text-gray-600">
                      {userInfo.name ? userInfo.name.charAt(0).toUpperCase() : <User size={14} />}
                    </span>
                  )}
                </span>
                <span>{userInfo.name}</span>
              </Link>
            ) : (
              <Link
                to="/login"
                className="ml-5 flex cursor-pointer justify-center items-center gap-2 text-sm"
              >
                <span>
                  <Lock size={18} />
                </span>
                <span>Login</span>
              </Link>
            )}
            <div className="flex justify-center ml-2">
              <div
                onClick={() =>
                  navigate(userInfo ? "/dashboard/my-wishlist" : "/login")
                }
                className="relative flex justify-center items-center cursor-pointer w-[35px] h-[35px]"
              >
                <span className="text-xl text-gray-700">
                  <Heart size={20} />
                </span>
                {wishlist_count !== 0 && (
                  <div className="w-[25px] h-[25px] absolute rounded-full text-[10px] bg-red-600 text-white flex justify-center items-center -top-[5px] -right-[7px]">
                    {wishlist_count}
                  </div>
                )}
              </div>
              <div
                onClick={redirect_cart_page}
                className="relative flex justify-center items-center cursor-pointer w-[35px] h-[35px]"
              >
                <span className="text-xl text-gray-700">
                  <ShoppingBag size={20} />
                </span>
                {card_product_count !== 0 && (
                  <div className="w-[25px] h-[25px] absolute rounded-full text-white text-[10px] bg-red-600  flex justify-center items-center -top-[5px] -right-[7px]">
                    {card_product_count}
                  </div>
                )}
              </div>
            </div>
            </div>
          
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeadersDashboard;
